module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addExtraForStu
    }
  }, [_vm._v("关联特色课程")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "760",
      "footer-hide": ""
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "15px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._v("关联特色课程")])], 1), _vm._v(" "), _c('div', [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formExtra,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "特色课程名称:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入特色课程名称"
    },
    model: {
      value: (_vm.formExtra.name),
      callback: function($$v) {
        _vm.$set(_vm.formExtra, "name", $$v)
      },
      expression: "formExtra.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "级别:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入特色课程级别"
    },
    model: {
      value: (_vm.formExtra.level),
      callback: function($$v) {
        _vm.$set(_vm.formExtra, "level", $$v)
      },
      expression: "formExtra.level"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.onQuery
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    ref: "multipleTable",
    staticClass: "elTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.queryData,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "特色课程ID",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewExtra(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "特色课程名称",
      "align": "center",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewExtra(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "label": "级别",
      "align": "center",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "数量",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "enabled",
      "label": "状态",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.enabled) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已上架")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已下架")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('Divider'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "300px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modalConfirm
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modalCancel
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26297bb3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/componentsEdu/stuAddExtra.vue
// module id = 667
// module chunks = 1